module.exports = __webpack_public_path__ + "media/img/pole_e-c58aaf9c.png";